export const DOCUMENT_GROUP_NAMES = {
  ALL: 'All',
  REPORTS: 'Reports',
  SURVEILLANCE: 'Surveillance',
  OTHER: 'Other',
};

export const DEFAULT = {
  groupId: null,
  groupName: 'All',
  documentTypeCollection: [],
};

class DocumentGroup {
  isValid(collection, documentGroupName: string) {
    return (
      !!documentGroupName
      && collection.some((item) => item.groupName.toLowerCase() === documentGroupName.toLowerCase())
      ) ||
           (!!documentGroupName && this.getDefault().groupName.toLowerCase() === documentGroupName.toLowerCase());
  }

  getDefault() {
    return DEFAULT;
  }

  getByGroupName(collection, documentGroupName: string = '') {
    let byName = collection.find((item) => item.groupName.toLowerCase() === documentGroupName.toLowerCase());
    if (byName) {
      return byName;
    }

    return this.getDefault();
  }
}

export default DocumentGroup;
